/**
 * Where focus goes when the person moves to another screen inside this application: to the new
 * screen's main heading, once it is on the page, so a keyboard or screen reader continues from the top
 * of what changed instead of from the document. The first screen of a visit keeps the browser's own
 * focus; only a move inside the application is expected.
 */
export class Arrival {
	#expected = false;
	#seen?: string;

	/** Notes the screen in view, by a key that changes when the screen does; a change expects a heading */
	at(key: string): void {
		if (this.#seen !== undefined && this.#seen !== key) this.#expected = true;
		this.#seen = key;
	}

	/** A ref for a screen's main heading, which needs `tabIndex={-1}`: focused when it appears after a move */
	heading = (node: HTMLElement | null): void => {
		if (!node || !this.#expected) return;
		this.#expected = false;
		node.focus();
	};
}
